<div class="seek-container">
  <div *ngIf="(!isLive && !isAd && (seeking || seekingWithMouse || automaticSeek)) && currentThumbnail" class="seekbar-thumbnails">
    <div
      class="seekbar-thumbnails-item" 
      [ngStyle]="{
        'background-image': currentThumbnail?.backgroundImage,
        'background-position': currentThumbnail?.backgroundPosition,
        'background-size': currentThumbnail?.backgroundSize,
        'height': currentThumbnail?.height,
        'width': currentThumbnail?.width,
        'margin-left': ((percentage > 15 ? percentage <= 85 ? percentage : 90 : 10) - 10).toString() + '%'
      }">
    <span class="seekbar-thumbnails-item-time">{{ innerValue | secondsToTimePlayer }}</span></div>
  </div>
  <div
    id="seekbar-focusable-button"
    #button
    tabindex="0"
    class="seekbar-button focusable-element"
    [ngClass]="{ 'ad': isAd }"
    [ngStyle]="{ left: percentage.toString() + '%' }"
    (keydown)="onKeyDown($event)"
  ></div>
  <ng-container *ngIf="showCuepoints">
      <div class="cuepoint-container">
        <div *ngFor="let point of cuepoints" class="cuepoint"  [ngClass]="{ 'ad': isAd }"
          [ngStyle]="{ left: (max | playerSeekbar: point.startTime) + '%' }"
          ></div>
      </div>
  </ng-container>
  <div #bar class="seekbar-bar" [ngStyle]="{ width: percentage.toString() + '%' }" [ngClass]="{ 'ad': isAd }"></div>
</div>